import { createContext } from "react";

export interface AuthContextInterface {
  accessToken: string | null;
  setAccessToken(token: string | null): void;
  handleLogOutUser(invalidateToken?:boolean): void;
}

const InitialState: AuthContextInterface = {
  accessToken: "",
  setAccessToken: () => null,
  handleLogOutUser: (invalidateToken?: boolean) => null,
};

const AuthContext = createContext(InitialState);
export default AuthContext;
